import { createRouter, createWebHistory } from '@ionic/vue-router';
import { routes } from './routes';
import { authGuard } from './auth-guard';
import { orientationGuard } from './orientation-guard';
import { logEvent } from '@/services/analytics';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(authGuard);
router.beforeEach(orientationGuard);

router.afterEach(to => {
  const screenName = to.name?.toString() ?? to.path;
  void logEvent('screen_view', { screen_name: screenName });
});

export default router;
export * from './types';
